import { JoinSessionButtonWrapper } from '../admission/JoinSessionButtonWrapper';

export function JoinSessionCta() {
  return (
    <div className='flex flex-col gap-4 mt-4'>
      <JoinSessionButtonWrapper />
    </div>
  );
}
